import { Drawer, paperClasses } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "DrawerSocialOfferStyled";

export const classes = {
  root: `${PREFIX}-root`,
  header: `${PREFIX}-header`,
};

export const DrawerSocialOfferStyled = styled(Drawer)(({ theme }) => ({
  [`&.${classes.root}`]: {
    zIndex: 1300,
    [`& > .${paperClasses.root}`]: {
      height: `calc(100% - ${theme.navbarSize})`,
      width: "750px",
      top: theme.navbarSize,
      padding: theme.spacing(3),
    },
    [`& .${classes.header}`]: {
      paddingBottom: theme.spacing(4),
    },
  },
}));
